import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CommonService, Code, Zipcode } from '../app.service';
import { Cargo, CargoService } from './cargo.service';
import { AppConstants, SERVER, LOGON_INFO, CODE, CARGO_LIST_TYPE, CARGO_STATUS, DATEPICKER } from '../app.constants';
import { INgxMyDpOptions } from 'ngx-mydatepicker';
import { GooglemapService, LocationInfo } from '../common/googlemap.service';
import { MessageService } from '../common/message.service';
import { CarService, Car } from '../member-kanri/car.service';
import { MobileService } from '../mobile/mobile.service';
import $ from 'jquery';

declare let google: any;


@Component({
    selector: 'client-cargo',
    templateUrl: 'client-cargo.component.html',
    providers: [CargoService, GooglemapService, CarService, MobileService]
})
export class ClientCargoComponent implements OnInit, OnDestroy {

    CARGO_LIST_TYPE: any = CARGO_LIST_TYPE;
    CONST: any = AppConstants;
    CARGO_STATUS: any = CARGO_STATUS;

    @ViewChild(NgForm) f: NgForm;

    myDatePickerOptions: INgxMyDpOptions = DATEPICKER.myDatePickerOptions;
    myDatePickerOptions_noDisableUntil: INgxMyDpOptions = DATEPICKER.myDatePickerOptions_noDisableUntil;
    
    cargoList: Cargo[];
    currentCargo: Cargo;

    timeDivideCodeList: Code[];
    loadMethodCodeList: Code[];
    carAbilityCodeList: Code[];
    chargeUnitCodeList: Code[];
    todohukenList: any[];

    search_load_todohuken: string = "";
    search_load_date_start: any;
    search_load_date_end: any;

    //pagination
    perPage: number = AppConstants.PAGE_SIZE_LARGE;
    currPage: number;
    totalCount: number;

    search_div: string;
    address_search_list: LocationInfo[];

    //地図表示用
    isMapShow: boolean = true;
    selCar: Car;
    origin: any;
    destination: any;

    clientSocket: any;

    deviceLat: number;
    deviceLng: number;

    hour_list: string[] = ["00","01","02","03","04","05","06","07","08","09","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24"];


    constructor(
        private commonService: CommonService,
        private mapService: GooglemapService,
        private cargoService: CargoService,
        private msgService: MessageService,
        private carService: CarService,
        private mobileService: MobileService
    ) {  }


    ngOnInit() {
        this.timeDivideCodeList = CODE.TIME_DIVIDE;
        this.loadMethodCodeList = CODE.LOAD_METHOD;
        this.carAbilityCodeList = CODE.CAR_ABILITY;
        this.chargeUnitCodeList = CODE.CHARGE_UNIT;
        this.todohukenList = CODE.TODOHUKEN;

        this.clearSelectCargo();

        this.currPage = 1;
        
        this.getCargoList(null, null);

        this.clientSocket = new WebSocket(SERVER.socketURL + '/client/');
        
        this.clientSocket.addEventListener("message", (event) => {
            var data = JSON.parse(event.data);
            var div: string = data['div'];
            var cargo: Cargo = data['cargo'];
            this.autoRefresh(div, cargo);
        });

        this.getDevicePosition();

        //数字入力欄で最大桁数以上は自動入力不可とする
        $(function() {
            $('input[type="number"]').on('input', function() {
                if (this.value.length > this.maxLength) {
                    this.value = this.value.slice(0, this.maxLength);
                }
            });
        });
    }



    autoRefresh(div: string, cargo: Cargo) {
        //表示中であれば入れ替え
        if (!this.cargoService.replaceCargoFromList(this.cargoList, cargo)) {
            //表示中ではなく、自社が登録した貨物の場合
            if ((LOGON_INFO.COMP_ID == "C00000" && LOGON_INFO.USER_ID == cargo.create_id)
                 || (LOGON_INFO.COMP_ID != "C00000" && cargo.client_comp_id == LOGON_INFO.COMP_ID)) {
                //リストに貨物追加
                if(this.cargoService.addCargoToList(this.cargoList, cargo, null)) {
                    this.totalCount = this.totalCount + 1;
                }
            }
        }
    }



    ////////// 住所選択 START ///////////////////////////////////////////////////

    //住所検索ボタン押下
    searchAddress(div: string) {
        this.search_div = div;
        let searchKeyword = this.f.controls[div+'_search'];
        searchKeyword.setValue(searchKeyword.value.trim().replace(/-/g,''));
        if (searchKeyword.value.length >= 2) {
            this.commonService.searchAddress(searchKeyword.value)
                    .take(1).subscribe(
                        data => {
                            this.address_search_list = data['results'];
                            if (this.address_search_list.length > 1) {
                                $('#addressSearchModal').modal('show');
                            }
                            else if (this.address_search_list.length == 1) {
                                this.setAddress(this.address_search_list[0]);
                            }
                            else {
                                this.msgService.addError("該当する住所が見つかりません。");
                            }
                        }
                    );
        } else {
            this.msgService.addError("２桁以上の文字列を入力してください。");
        }
    }

    //地図から選択ボタン押下
    selectFromMap(div: string) {
        this.search_div = div;
        $('#mapModal').modal('show');
    }

    //履歴から選択ボタン押下
    selectFromHistory(div: string) {
        this.search_div = div;
        this.cargoService.getAddressHistoryList(div)
            .take(1).subscribe(
                    data => {
                        this.address_search_list = data['results'];
                        if (this.address_search_list.length > 0) {
                            $('#addressSearchModal').modal('show');
                        } else {
                            this.msgService.addInfo("履歴が見つかりません。");
                        }
                    }
                );
    }

    //住所選択modalからのcallback
    setAddress(locInfo: LocationInfo) {
        if (this.search_div == AppConstants.LOAD) {
            this.currentCargo.load_latitude = locInfo.lat;
            this.currentCargo.load_longitude = locInfo.lng;
            this.currentCargo.load_todohuken = locInfo.todohuken;
            this.currentCargo.load_address = locInfo.address;
        } else {
            this.currentCargo.drop_latitude = locInfo.lat;
            this.currentCargo.drop_longitude = locInfo.lng;
            this.currentCargo.drop_todohuken = locInfo.todohuken;
            this.currentCargo.drop_address = locInfo.address;
        }
    }

    getDevicePosition(): void {
        this.mobileService.getDeviceCurrentLocation()
        .then(
            (data) => {
                this.deviceLat = data[0];
                this.deviceLng = data[1];
            }
        )
        .catch(
            (error) => {
                //
            }
        );
    }

    inputDevicePosition(div: string) {
        this.mapService.getAddressFromLatLng(this.deviceLat, this.deviceLng)
        .then(
            (data) => {
                if (div == AppConstants.LOAD) {
                    this.currentCargo.load_todohuken = data.todohuken;
                    this.currentCargo.load_address = data.address;
                    this.currentCargo.load_latitude = this.deviceLat;
                    this.currentCargo.load_longitude = this.deviceLng;
                } else {
                    this.currentCargo.drop_todohuken = data.todohuken;
                    this.currentCargo.drop_address = data.address;
                    this.currentCargo.drop_latitude = this.deviceLat;
                    this.currentCargo.drop_longitude = this.deviceLng;
                }
            }
        )
        .catch(
            (error) => {
                this.msgService.addError(error);
            }
        );
    }

    ////////// 住所選択 END ///////////////////////////////////////////////////


    toggleMap() {
        this.isMapShow = !this.isMapShow;
    }


    //貨物リスト取得
    getCargoList(searchDateStart:any, searchDateEnd:any) {
        this.cargoService.getCargoList(CARGO_LIST_TYPE.REQUEST, this.currPage, '', this.search_load_todohuken, searchDateStart, searchDateEnd)
            .take(1).subscribe(
                data => {
                    this.cargoList = data['results'];
                    this.totalCount = data['count'];
                }
            );
    }


    //ページ移動
    pageChange(page: number) {
        this.currPage = page;
        this.getCargoList(this.search_load_date_start, this.search_load_date_end);
    }


    //貨物選択
    onSelect(cargo: Cargo): void {
        if (this.currentCargo.id == cargo.id) {
            return;
        }
        //objectをコピー
        this.currentCargo = Object.assign({},cargo);
        this.currentCargo.load_date =  { jsdate: new Date(cargo.load_date), formatted: cargo.load_date };
        this.currentCargo.load_date_end =  { jsdate: new Date(cargo.load_date_end), formatted: cargo.load_date_end };
        this.currentCargo.drop_date =  { jsdate: new Date(cargo.drop_date), formatted: cargo.drop_date };
        this.currentCargo.drop_date_end =  { jsdate: new Date(cargo.drop_date_end), formatted: cargo.drop_date_end };

        this.origin = {lat:+cargo.load_latitude, lng:+cargo.load_longitude};
        this.destination = {lat:+cargo.drop_latitude, lng:+cargo.drop_longitude};

        if (this.currentCargo.trans_car_id /*&& this.currentCargo.status != CARGO_STATUS.MATCH_CAR*/) {
            this.carService.getCar(this.currentCargo.trans_car_id)
            .take(1).subscribe(
                data => this.selCar = data['results'][0]
            );
        }
        else {
            this.selCar = null;
        }
    }


    //貨物登録
    async registCargo() {
        this.currentCargo.status = CARGO_STATUS.REGIST;

        if(this.commonService.checkStartEndDate(this.currentCargo.load_date, this.currentCargo.load_time, this.currentCargo.load_date_end, this.currentCargo.load_time_end, true, false, false)
             && this.commonService.checkStartEndDate(this.currentCargo.drop_date, this.currentCargo.drop_time, this.currentCargo.drop_date_end, this.currentCargo.drop_time_end, true, false, false)
             && this.commonService.checkStartEndDate(this.currentCargo.load_date, this.currentCargo.load_time, this.currentCargo.drop_date, this.currentCargo.drop_time, false, false, false))
        {
            await this.getLatLng();

            await this.cargoService.registCargo(this.currentCargo)
                .take(1).subscribe(
                    data => {
                        this.refreshPage(AppConstants.REGIST, data);
                    }
                );
        }
    }


    //貨物修正
    async updateCargo() {
        await this.getLatLng();
        
        //貨物情報を更新
        await this.cargoService.updateCargo(this.currentCargo)
            .take(1).subscribe(
                data => {
                    this.refreshPage(AppConstants.UPDATE, data);
                }
            );
    }


    


    //住所から地図座標を取得
    async getLatLng() {
        //積み地の地図座標を取得
        await this.mapService.getLatLngFromAddress(this.currentCargo.load_todohuken + this.currentCargo.load_address)
        .then(
            data => {
                this.currentCargo.load_latitude = data.lat();
                this.currentCargo.load_longitude = data.lng();
                //this.msgService.clear();
            }
        )
        .catch(
            error => {
                this.currentCargo.load_latitude = null;
                this.currentCargo.load_longitude = null;
                //this.msgService.add(error);
            }
        );
    
        //卸し地の地図座標を取得
        await this.mapService.getLatLngFromAddress(this.currentCargo.drop_todohuken + this.currentCargo.drop_address)
        .then(
            data => {
                this.currentCargo.drop_latitude = data.lat();
                this.currentCargo.drop_longitude = data.lng();
                //this.msgService.clear();
            }
        ).catch(
            error => {
                this.currentCargo.drop_latitude = null;
                this.currentCargo.drop_longitude = null;
                //this.msgService.add(error);
            }
        );
    }

    //貨物運送依頼取消
    cancelCargo() {
        //運送開始された貨物は削除できない
        if (this.currentCargo.status == CARGO_STATUS.TRANS_START) {
            this.msgService.addError("運送開始の貨物は削除できません。運送会社に問い合わせください。");
        } else {
            this.cargoService.cancelCargo(this.currentCargo.id)
            .take(1).subscribe(
                data => {
                    this.refreshPage(AppConstants.UPDATE, data);
                }
            );
        }
    }


    //貨物削除（論理削除）
    /*
    deleteCargo() {
        //運送開始された貨物は削除できない
        if (this.currentCargo.status == CARGO_STATUS.TRANS_START) {
            this.msgService.add("運送開始の貨物は削除できません。運送会社に問い合わせください。");
        } else {
            this.cargoService.deleteCargo(this.currentCargo.id)
            .take(1).subscribe(
                data => {
                    this.getCargoList();
                    this.clearSelectCargo();
                }
            );
        }
    }
    */


    //画面リフレッシュ
   refreshPage(div: string, cargo: Cargo) {
        //send websocket  
        this.clientSocket.send(JSON.stringify({
            'div': div,
            'cargo_id': cargo.id
        }));

        /*
        if (div == AppConstants.REGIST) {
            if (this.cargoList.length >= this.perPage) {
                this.cargoList.pop();
            }
            this.cargoList.unshift(cargo);
        } else {
            let idx = this.cargoList.findIndex(({id}) => id === cargo.id);
            if (idx > -1) {
                this.cargoList.splice(idx, 1, cargo);
            } 
        }
        */

        this.clearSelectCargo();
    }


    //入力情報のクリア
    clearSelectCargo(): void {
        let now = new Date();
        //入力formを初期化
        this.currentCargo = new Cargo();
        this.currentCargo.load_date = { jsdate: now, formatted: now.toLocaleDateString() };
        this.currentCargo.load_date_end = { jsdate: now, formatted: now.toLocaleDateString() };
        this.currentCargo.drop_date = { jsdate: now, formatted: now.toLocaleDateString() };
        this.currentCargo.drop_date_end = { jsdate: now, formatted: now.toLocaleDateString() };
        // this.currentCargo.load_time = "09";
        // this.currentCargo.drop_time = "09";
        this.currentCargo.commission = 0;
        this.currentCargo.cargo_num = 1;
        this.currentCargo.charter_flag = false;
        this.currentCargo.cool_flag = false;
        this.f.resetForm(this.currentCargo);

        //地図表示用objectを初期化
        this.origin = null;
        this.destination = null;
        this.selCar = new Car();

        //エラーメッセージを初期化
        //this.msgService.clearAll();
    }




    exec() {
        switch ($('#confirmModal_btn').text()) {
            case "登録":
                this.registCargo();
                break;
            case "修正":
                this.updateCargo();
                break;
            case "取消":
                this.cancelCargo();
                break;
            /*
            case "削除":
                this.deleteCargo();
                break;
            */
            case "複写":
                this.registCargo();
                break;
        }
    }



    listExportAsExcel() {
        this.commonService.exportAsExcelFile(this.cargoList, "貨物運送依頼リスト", false);
    }


    searchDateChange(type: string, event: any) {
        if (type == "start" && (!this.search_load_date_start || this.search_load_date_start.formatted != event.formatted)) {
            this.getCargoList(event, this.search_load_date_end);
        }
        else if (type == "end" && (!this.search_load_date_end || this.search_load_date_end.formatted != event.formatted)) {
            this.getCargoList(this.search_load_date_start, event);
        }
    }



    ngOnDestroy() {
        this.clientSocket.close();

        //Modalが開いた状態でブラウザの前ページへ移動ボタン押下すると、modalは閉じられるがbackdropが消えない
        //強制的にbackdropを消す
        $(".modal-backdrop").remove();
    }

}


// WEBPACK FOOTER //
// ./src/app/cargo/client-cargo.component.ts